import React, { useEffect, useState } from "react";
import axios from "axios";
import "aos/dist/aos.css";
import { FaEye, FaArrowLeft, FaArrowRight, FaTimes } from "react-icons/fa";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";

const Awards = () => {
  // const [awards, setAwards] = useState([]);
  const [awards, setAwards] = useState([]);
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(null);

  // ✅ Fetch API data
  useEffect(() => {
  axios
      .get("https://www.isolsgroup.com/new/api/ApiAwards", {
        headers: { "X-API-KEY": "ISOLS" },
      })
      .then((res) => {
        console.log("Awards API Response:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          setAwards(res.data.data);
        }
      })
      .catch((err) => console.error("Error fetching videos:", err));

    // Fetch text testimonials
    axios
      .get("https://www.isolsgroup.com/new/api/ApiLetterAssociation", {
        headers: { "X-API-KEY": "ISOLS" },
      })
      .then((res) => {
        console.log("Letters API Response:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          setLetters(res.data.data);
        }
      })
      .catch((err) => console.error("Error fetching testimonials:", err))
      .finally(() => setLoading(false));

  }, []);

  // ✅ Next / Prev Handlers
  const handleNext = () => {
    setSelectedIndex((selectedIndex + 1) % awards.length);
  };

  const handlePrev = () => {
    setSelectedIndex((selectedIndex - 1 + awards.length) % awards.length);
  };

  return (
    <div className="page-container" id="missionidd">
      {/* Breadcrumbs Section */}
      <BreadcrumbsHeader 
        title="Awards & Recognitions" 
        backgroundImage="/images/header/about-isols.jpg" 
      />



      {/* Awards Section */}
      <div id="awards-certifications" style={{ paddingTop: "50px" }}>
        <h2 className="termm text-center">
          Recognitions and Certifications We Have Achieved
        </h2>
      </div>
      <section className="pi-section-w pi-section-white">
        <div className="pi-section pi-padding-bottom-0">
          <div className="container">
            <div
              className="pi-row pi-gallery"
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                justifyContent: "center",
              }}
            >
              {loading ? (
              <p className="text-center">Loading Awards...</p>
            ) :
              awards.length > 0 ? (
                awards.map((item, index) => (
                  <div
                    key={index}
                    className="pi-gallery-item"
                    style={{
                      width: "calc(25% - 20px)",
                      textAlign: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => setSelectedIndex(index)}
                  >
                    <div className="pi-img-w" style={{ position: "relative" }}>
                      <img
                        src={`https://www.isolsgroup.com/new/uploaded-images/awards/${item.image}`}
                        alt={item.heading}
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        }}
                      />
                      <div
                        className="pi-img-overlay"
                        style={{
                          position: "absolute",
                          inset: 0,
                          backgroundColor: "rgba(0,0,0,0.4)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          opacity: 0,
                          transition: "opacity 0.3s",
                        }}
                      >
                        <FaEye size={30} color="#fff" />
                      </div>
                    </div>
                    <h4 style={{ marginTop: "15px" }}>{item.heading}</h4>
                    <p
                      style={{ fontSize: "14px", color: "#555" }}
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }}
                    />
                  </div>
                ))
              ) : (
                <p className="text-center mt-4">
                  No Awards or Recognitions available.
                </p>
              )}
            </div>
          </div>

          {/* ✅ Popup Section */}
          {selectedIndex !== null && awards[selectedIndex] && (
            <div
              onClick={() => setSelectedIndex(null)}
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.85)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: "relative",
                  textAlign: "center",
                }}
              >
                {/* Close Button */}
                <button
                  onClick={() => setSelectedIndex(null)}
                  style={{
                    position: "absolute",
                    top: "-40px",
                    right: "0",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                    fontSize: "28px",
                  }}
                >
                  <FaTimes />
                </button>

                {/* Left Arrow */}
                <button
                  onClick={handlePrev}
                  style={{
                    position: "absolute",
                    left: "-60px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                    fontSize: "32px",
                  }}
                >
                  <FaArrowLeft />
                </button>

                {/* Image */}
                <img
                  src={`https://www.isolsgroup.com/new/uploaded-images/awards/${awards[selectedIndex].image}`}
                  alt={awards[selectedIndex].title}
                  style={{
                    maxWidth: "90vw",
                    maxHeight: "80vh",
                    borderRadius: "10px",
                    boxShadow: "0 4px 20px rgba(255,255,255,0.3)",
                  }}
                />

                {/* Right Arrow */}
                <button
                  onClick={handleNext}
                  style={{
                    position: "absolute",
                    right: "-60px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                    fontSize: "32px",
                  }}
                >
                  <FaArrowRight />
                </button>

                {/* Title */}
                <h4 style={{ color: "#fff", marginTop: "15px" }}>
                  {awards[selectedIndex].title}
                </h4>
              </div>
            </div>
          )}
        </div>
      </section>

          {/* Letter of Association Section */}
      <div
        className="b-home-team relative"
        style={{ background: "#f9f9fa", padding: "40px 0" }}
      >
        <div className="container">
          <div className="row">
            <div className="b-team">
              <div className="col-xs-12 col-sm-12">
                <div
                  className="b-member-info"
                  style={{
                    float: "left",
                    listStyle: "none",
                    position: "relative",
                    marginBottom: "20px",
                  }}
                >
                  <div className="col-xs-12 col-sm-3">
                    <div className="b-mod-heading">
                      <p className="first-heading font-secondary member-prof">
                        Letter of{" "}
                      </p>
                      <h4
                        className="heading-line line-right customColor customPseudoElBg member-name"
                        style={{ fontSize: "38px" }}
                      >
                        <strong>Association</strong>
                      </h4>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-9">
                    <div className="b-member-caption">
                      <h6 className="contact-info-title customPseudoElBg font-secondary">
                        Letter of Association, Appreciation & Institutional
                        Partnership
                      </h6>
                      <p>
                        We are proud to be the Education Partner with IIT Bombay
                        and to have received a Letter of Appreciation from PNB
                        Bank for Cyber Crime Awareness Training. We also
                        received an Exclusive Invitation from Bharat Mandapam
                        for prestigious national events.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Partner Letters */}
              <div className="col-xs-12 col-sm-12">
                <div className="row">
                  <div className="bx-wrapper letter">
                    <div className="bx-viewport">
                      <div
                        className="member-list-item clearfix"
                        style={{
                          float: "left",
                          listStyle: "none",
                          position: "relative",
                        }}
                      >
                        
                        {loading ? (
                          <p className="text-center">Loading Letters...</p>
                        ) :
                        letters.length > 0 ? (
                        letters.map((letter, index) => (
                        <div className="col-xs-12 col-sm-3 text-center">
                          <div className="member-img">
                            <img
                              src={`https://www.isolsgroup.com/new/uploaded-images/association/${letter.image}`}
                              className="img-responsive"
                              alt={letter.name}
                            />
                          </div>
                          <div className="awrds">
                            <h3>{letter.name}</h3>
                          </div>
                        </div>
                        ))
                        ) : (
                        <p className="text-center mt-4">No Data available.</p>
                        )}

                      </div>
                    </div>
                    <div className="bx-controls"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Awards;
